const areAiFeaturesUsed = ({
  numberOfAiGeneratedPages = null,
  numberOfAiGeneratedBlocks = null,
  numberOfAiTextAssistantRequests = null,
}) =>
  Boolean(numberOfAiGeneratedPages || numberOfAiGeneratedBlocks || numberOfAiTextAssistantRequests);

export default areAiFeaturesUsed;
